<div class="row">
  <div class="card" style="border-color: aliceblue !important">
    <div class="card-body">
      <div class="d-grid gap-2 d-flex">
        <button
          class="btn btn-primary"
          (click)="this.selectedTab = 0"
          [class.active]="selectedTab == 0"
          type="button"
        >
          Customer Details
        </button>
        <button
          class="btn btn-primary"
          (click)="this.selectedTab = 1"
          [class.active]="selectedTab == 1"
          type="button"
        >
          KYC Documents
        </button>
        <button
          class="btn btn-primary"
          *ngIf="!permissions.includes('View')"
          (click)="this.selectedTab = 2"
          [class.active]="selectedTab == 2"
          type="button"
        >
          Screening Report
        </button>
        <button
          class="btn btn-primary"
          (click)="this.selectedTab = 3"
          [class.active]="selectedTab == 3"
          type="button"
        >
          Verification Details
        </button>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div
    class="card"
    [ngStyle]="{ display: selectedTab == 0 ? 'block' : 'none' }"
  >
    <div class="card-header d-flex justify-content-between align-items-center">
      <label
        class="col-form-label"
        style="font-weight: bolder; font-size: x-large; margin: 0"
      >
        Customer Details
        <span style="color: #6571ff">{{ "(" + userId + ")" }}</span>
      </label>
      <!-- Single Unmask Button for All PII Fields -->
      <button
        type="button"
        class="btn bg-danger-custom btn-sm"
        (click)="unmaskAllPiiFields()"
        title="Unmask All PII Fields"
      >
        <img
          src="assets/images/unmask-icon.png"
          alt="Unmask All"
          style="
            width: 16px;
            height: 16px;
            margin-right: 5px;
            filter: brightness(0) invert(1);
          "
        />
        Unmask All PII
      </button>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-sm-4">
          <label class="col-form-label" for="fullName">Customer Name </label>
          <input
            class="form-control"
            id="fullName"
            readonly
            type="text"
            [(ngModel)]="fname"
            name="fname"
          />
        </div>
        <div class="col-sm-4">
          <label class="col-form-label" for="dob">Date of Birth</label>
          <input
            class="form-control"
            readonly
            id="personName"
            type="text"
            autocomplete="new-password"
            [(ngModel)]="dob"
            name="dob"
          />
        </div>
        <div class="col-sm-4">
          <label class="col-form-label" for="nationality">Nationality</label>
          <input
            class="form-control"
            readonly
            id="nationality"
            type="text"
            autocomplete="new-password"
            [(ngModel)]="nationality"
            name="nationality"
          />
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-sm-4">
          <label class="col-form-label" for="documentType">Document Type</label>
          <input
            class="form-control"
            readonly
            id="documentType"
            type="text"
            autocomplete="new-password"
            [(ngModel)]="documentType"
            name="documentType"
          />
        </div>
        <div class="col-sm-4">
          <label class="col-form-label" for="eid">Document ID</label>
          <input
            class="form-control"
            readonly
            id="eid"
            type="text"
            autocomplete="new-password"
            [(ngModel)]="eid"
            name="eid"
          />
        </div>
        <div class="col-sm-4">
          <label class="col-form-label" for="emiratesExpiry">Document Expiry Date</label>
          <input
            class="form-control"
            readonly
            id="emiratesExpiry"
            type="text"
            autocomplete="new-password"
            [(ngModel)]="emiratesExpiry"
            name="emiratesExpiry"
          />
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-sm-4">
          <label class="col-form-label" for="kycType">Wallet level</label>
          <input
            class="form-control"
            readonly
            id="kycType"
            type="text"
            autocomplete="new-password"
            [(ngModel)]="kycType"
            name="kycType"
          />
        </div>


         <div class="col-sm-4">
          <label class="col-form-label" for="address">Address</label>
          <input
            class="form-control"
            readonly
            id="address"
            type="text"
            autocomplete="new-password"
            [(ngModel)]="address"
            name="address"
          />
        </div>
        <!-- <div class="col-sm-4">
               <label class="col-form-label" for="emailId">Customer Email Id </label>
               <input class="form-control" readonly id="emailId" [(ngModel)]="emailId" autocomplete="new-password"
                  type="text" name="emailId">
            </div> -->
      </div>
      <!-- <br>
         <div class="row">
            <div class="col-sm-4">
               <label class="col-form-label" for="gender">Gender</label>
               <input class="form-control" readonly [(ngModel)]="gender" name="gender" id="gender" type="text"
                  autocomplete="new-password">
            </div>
         </div>
         <br>
         <div class="row">
            <div class="col-sm-4">
               <label class="col-form-label" for="passportNumber">Passport Number</label>
               <input class="form-control" readonly [(ngModel)]="passportNumber" name="passportNumber"
                  id="passportNumber" type="text" autocomplete="new-password">
            </div>
            <div class="col-sm-4">
                 <label class="col-form-label" for="passportType">Passport Type</label>
                 <div class="col-sm-9">
                    <input class="form-control" readonly [(ngModel)]="passportType" name="passportType" id="passportType"
                    type="text" autocomplete="new-password">
                 </div>
              </div>
            <div class="col-sm-4">
               <label class="col-form-label" for="passportExpiry">Passport Expiry Date</label>
               <input class="form-control" readonly [(ngModel)]="passportExpiry" name="passportExpiry"
                  id="passportExpiry" type="text" autocomplete="new-password">
            </div>
            <div class="col-sm-4">
               <label class="col-form-label" for="occupation">Occupation </label>
               <input class="form-control" readonly [(ngModel)]="occupation" name="occupation" id="occupation"
                  type="text" autocomplete="new-password">
            </div>
         </div> -->
      <br />
      <!-- <div class="row">
            <div class="col-sm-4">
               <label class="col-form-label" for="areaDesc">Address</label>
               <input class="form-control" readonly [(ngModel)]="areaDesc" name="areaDesc" id="areaDesc" type="text"
                  autocomplete="new-password">
            </div>
            <div class="col-sm-4">
               <label class="col-form-label" for="pob">Place of Birth</label>
               <input class="form-control" readonly [(ngModel)]="pob" name="pob" id="pob" type="text"
                  autocomplete="new-password">
            </div>
            <div class="col-sm-4">
                 <label class="col-form-label" for="emirate">Emirate</label>
                 <div class="col-sm-9">
                    <input class="form-control" readonly [(ngModel)]="emirate" name="emirate" id="emirate" type="text"
                    autocomplete="new-password">
                 </div>
              </div>
         </div> -->
      <!-- <br> -->
      <!-- <div class="row"> -->
      <!-- <div class="col-sm-4">
                 <label class="col-form-label" for="poBox">P. O. Box </label>
                 <div class="col-sm-9">
                    <input class="form-control" readonly [(ngModel)]="poBox" name="poBox" id="poBox" type="text"
                    autocomplete="new-password">
                 </div>
              </div> -->
      <!-- <div class="col-sm-4">
                 <label class="col-form-label" for="city">City</label>
                 <div class="col-sm-9">
                    <input class="form-control" readonly [(ngModel)]="city" name="city" id="city" type="text"
                    autocomplete="new-password">
                 </div>
              </div> -->
      <!-- </div> -->
    </div>
  </div>
  <div
    class="card"
    [ngStyle]="{ display: selectedTab == 1 ? 'block' : 'none' }"
  >
    <label
      class="col-form-label"
      style="font-weight: bolder; font-size: x-large; margin: 0"
    >
      KYC Documents
    </label>
    <div class="card-body">
      <!--For Notification Highliter-->
      <div class="row">
        <div *ngIf="status === 1" class="text-lg-center">
          <ngb-alert [dismissible]="false" [type]="'success'"
            ><i class="feather icon-thumbs-up"></i
            >{{
              "Kyc is
                  approved" | uppercase
            }}</ngb-alert
          >
        </div>
        <div *ngIf="status === 2" class="text-lg-center">
          <ngb-alert [dismissible]="false" [type]="'danger'"
            ><i class="feather icon-thumbs-down"></i>
            {{
              "Kyc is
                  rejected" | uppercase
            }}</ngb-alert
          >
        </div>
      </div>
      <div class="row">
        <div class="card">
          <div class="card-body">
            <!-- <h6 class="card-title">KYC Document List</h6> -->
            <!-- <div class="row">
                       <div class="col-sm-12 align-middle">
                          <h5 class="card-title">1. Screening Report</h5>
                       </div>
                       <div class="col-sm-12" [innerHTML]="screeningReportPdf">
                       </div>
                    </div> -->
            <!-- <div class="row" *ngIf="emiratesIdImage">
                     <div class="col-sm-12 align-middle">
                        <h5 class="card-title">Emirates ID Front Image</h5>
                     </div>
                     <div class="col-sm-12">
                        <button (click)="viewImageDocModal('Front')" class="mt-2 btn btn-primary">View Front Image</button>
                     </div>
                  </div> -->
            <div class="row" *ngIf="emiratesIdImage">
              <div class="col-12">
                <div class="kyc-document-section">
                  <div class="cnie-doc-box">
                    <i class="feather icon-file-text cnie-doc-icon"></i>
                    <h6 class="cnie-doc-title">CNIE Front Image</h6>
                    <p class="cnie-doc-text">This document contains PII data</p>
                    <button
                      type="button"
                      class="btn btn-primary"
                      (click)="
                        viewCnieDocument('CIN_FRONT', 'CNIE Front Image')
                      "
                    >
                      <i class="feather icon-eye"></i>View CNIE Front Image
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <!-- <div class="row" *ngIf="emiratesIdBackImage">
                     <div class="col-sm-12 align-middle">
                        <h5 class="card-title">Emirates ID Back Image</h5>
                     </div>
                     <div class="col-sm-12">
                        <button (click)="viewImageDocModal('Back')" class="mt-2 btn btn-primary">View Back Image</button>
                     </div>
                  </div> -->
            <div class="row" *ngIf="emiratesIdBackImage">
              <div class="col-12">
                <div class="kyc-document-section">
                  <div class="cnie-doc-box">
                    <i class="feather icon-file-text cnie-doc-icon"></i>
                    <h6 class="cnie-doc-title">CNIE Back Image</h6>
                    <p class="cnie-doc-text">This document contains PII data</p>
                    <button
                      type="button"
                      class="btn btn-primary"
                      (click)="viewCnieDocument('CIN_BACK', 'CNIE Back Image')"
                    >
                      <i class="feather icon-eye"></i>View CNIE Back Image
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div class="row" *ngIf="icpDocumentReport">
              <div class="col-12">
                <div class="kyc-document-section">
                  <app-pii-pdf-viewer
                    [encryptedPdfUrl]="icpDocumentReport"
                    reportTitle="Identity Verification Report"
                    reportType="Identity_Verification_Report"
                    [userId]="userId"
                    fieldName="identity_verification_report"
                    [readonly]="false"
                    [useIndividualUnmask]="true"
                    entityType="customer"
                    [entityMobile]="mobile"
                    [referenceId]="userId"
                    buttonText="View Identity Verification Report"
                    downloadText="Download Identity Verification Report"
                    [downloadable]="permissions.includes('Checker Review')"
                  >
                  </app-pii-pdf-viewer>
                </div>
              </div>
            </div>
            <br />
            <div class="row" *ngIf="efrDocumentReport">
              <div class="col-12">
                <div class="kyc-document-section">
                  <app-pii-pdf-viewer
                    [encryptedPdfUrl]="efrDocumentReport"
                    reportTitle="EFR KYC Report"
                    reportType="EFR"
                    [userId]="userId"
                    fieldName="efr_kyc_report"
                    [readonly]="false"
                    [useIndividualUnmask]="true"
                    entityType="customer"
                    [entityMobile]="mobile"
                    [referenceId]="userId"
                    buttonText="View EFR KYC Report"
                    downloadText="Download EFR Report"
                    [downloadable]="permissions.includes('Checker Review')"
                  >
                  </app-pii-pdf-viewer>
                </div>
              </div>
            </div>
            <br />
            <!-- UAE Pass Emirates ID -->
            <div class="row mb-4" *ngIf="uaePassEid">
              <div class="col-12">
                <div class="kyc-document-section">
                  <app-pii-pdf-viewer
                    [encryptedPdfUrl]="uaePassEid"
                    reportTitle="CNIE Document"
                    reportType="CNIE_Document"
                    [userId]="userId"
                    fieldName="cnie_document"
                    [readonly]="false"
                    [useIndividualUnmask]="true"
                    entityType="customer"
                    [entityMobile]="mobile"
                    [referenceId]="userId"
                    buttonText="View CNIE Document"
                    downloadText="Download CNIE Document"
                    [downloadable]="permissions.includes('Checker Review')"
                  >
                  </app-pii-pdf-viewer>
                </div>
              </div>
            </div>

            <!-- UAE Pass Passport -->
            <div class="row mb-4" *ngIf="uaePassPP">
              <div class="col-12">
                <div class="kyc-document-section">
                  <app-pii-pdf-viewer
                    [encryptedPdfUrl]="uaePassPP"
                    reportTitle="Passport Document"
                    reportType="Passport_Document"
                    [userId]="userId"
                    fieldName="passport_document"
                    [readonly]="false"
                    [useIndividualUnmask]="true"
                    entityType="customer"
                    [entityMobile]="mobile"
                    [referenceId]="userId"
                    buttonText="View Passport Document"
                    downloadText="Download Passport Document"
                    [downloadable]="permissions.includes('Checker Review')"
                  >
                  </app-pii-pdf-viewer>
                </div>
              </div>
            </div>

            <!-- UAE Pass Visa -->
            <div class="row mb-4" *ngIf="uaePassVisa">
              <div class="col-12">
                <div class="kyc-document-section">
                  <app-pii-pdf-viewer
                    [encryptedPdfUrl]="uaePassVisa"
                    reportTitle="Residence Permit"
                    reportType="Residence_Permit"
                    [userId]="userId"
                    fieldName="residence_permit"
                    [readonly]="false"
                    [useIndividualUnmask]="true"
                    entityType="customer"
                    [entityMobile]="mobile"
                    [referenceId]="userId"
                    buttonText="View Residence Permit"
                    downloadText="Download Residence Permit"
                    [downloadable]="permissions.includes('Checker Review')"
                  >
                  </app-pii-pdf-viewer>
                </div>
              </div>
            </div>

            <!-- <div class="row mt-4">
                     <div class="col-sm-12 align-middle">
                        <h5 class="card-title">3. Proof Of Address (POA)</h5>
                     </div>
                     <div class="col-sm-12">
                        <label class="form-label">File Upload <span aria-hidden="true" class="symbol required"
                              style="color:red;">*</span></label>
                        <br>
                        <div class="mb-3">
                           <label class="input-group-btn">
                              <input type="file" class="form-control form-control-sm"
                                 (change)="onPoaFileChange($event)" />
                           </label>
                        </div>
                     </div>
                     <div class="col-sm-12">
                        <button class="mt-2 btn btn-primary" [disabled]="!kycFileSrc" (click)="downloadFile()">Download</button>
                        <button class="mt-2 btn btn-primary" (click)="viewKycDoc()">View</button>
                     </div>
                  </div> -->
          </div>
        </div>
      </div>
      <!-- <div class="row g-3" style="margin-top: 30px;">
              <div class="col">
                 <input type="text" class="form-control" placeholder="Remarks" aria-label="Remarks">
              </div>
              <div class="col">
                 <button class="btn btn-success"><i class="feather icon-list"></i> Add Remarks</button>
              </div>
           </div> -->
      <!-- <div class="row" style="margin-top: 30px;">
              <div class="col-12">
                 <button (click)="approve()" class="btn btn-success"><i class="feather icon-thumbs-up"></i> Approve</button>
                 <button (click)="reject()" class="btn btn-danger"><i class="feather icon-thumbs-down"></i> Reject</button>
              </div>
           </div> -->
      <!--  approval section-->
      <!-- <div class="row"  style="margin-top: 30px;">
              <div class="col-md-12 stretch-card">
                 <div class="card">
                    <div class="card-body">
                       <h6 class="card-title">KYC Remark List</h6>
                       <div class="table-responsive">
                          <button type="button" (click)="exportexcel()" class="btn btn-light">Export CSV<i  class="feather icon-download"></i></button>
                          <table id="dataTableExample" class="table">
                             <thead>
                                <tr>
                                   <th>Serial No</th>
                                   <th>Application Status</th>
                                   <th style="min-width:50px;">Application Remarks</th>
                                   <th>Added By</th>
                                   <th>Added On</th>
                                </tr>
                             </thead>
                             <tbody>
                                <td style="text-align: center;padding: 20px;" colspan="4" [style.display]="!this.remarkData || this.remarkData.length==0 ? 'block' : 'none'">No Data Found</td>
                             </tbody>
                             <tfoot>
                                <tr>
                                   <th></th>
                                   <th></th>
                                   <th></th>
                                   <th></th>
                                </tr>
                             </tfoot>
                          </table>
                       </div>
                    </div>
                 </div>
              </div>
           </div> -->
    </div>
  </div>







































    <div
    class="card"
    [ngStyle]="{ display: selectedTab == 3 ? 'block' : 'none' }"
  >
    <label
      class="col-form-label"
      style="font-weight: bolder; font-size: x-large; margin: 0"
    >
      Verification Details
    </label>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <h5 class="mb-3">Video KYC Result</h5>
        </div>
        <div class="col-md-4">
          <ul class="row">
            <li class="col-md-6"><label>Agent</label></li>
            <li class="col-md-6">
              <span>{{ kycResponse?.agentIdentifier || "NA" }}</span>
            </li>
          </ul>
        </div>
        <div class="col-md-4">
          <ul class="row">
            <li class="col-md-6"><label>Final Status</label></li>
            <li class="col-md-6">
              <span>{{ kycResponse?.finalStatus || "NA" }}</span>
            </li>
          </ul>
        </div>
        <div class="col-md-4">
          <ul class="row">
            <li class="col-md-6"><label>Face Match Status</label></li>
            <li class="col-md-6">
              <span>{{ kycResponse?.faceMatchStatus || "NA" }}</span>
            </li>
          </ul>
        </div>
        <div class="col-md-4">
          <ul class="row">
            <li class="col-md-6"><label>Call Start Time</label></li>
            <li class="col-md-6">
              <span>{{ kycResponse?.callStartTime || "NA" }}</span>
            </li>
          </ul>
        </div>
        <div class="col-md-4">
          <ul class="row">
            <li class="col-md-6"><label>Call End Time</label></li>
            <li class="col-md-6">
              <span>{{ kycResponse?.callEndTime || "NA" }}</span>
            </li>
          </ul>
        </div>
        <div class="col-md-4">
          <ul class="row">
            <li class="col-md-6"><label>Submitted At</label></li>
            <li class="col-md-6">
              <span>{{ kycResponse?.submittedAt || "NA" }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="row" *ngIf="kycResponse?.questions?.length">
        <div class="col-md-12">
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead class="thead-light">
                <tr>
                  <th id="sortable" scope="col">Question</th>
                  <th id="sortable" scope="col">Match Status</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let q of kycResponse.questions">
                  <td>{{ q.question }}</td>
                  <td>{{ q.matchStatus }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <hr />
      <div class="row">
        <div class="col-md-12">
          <h5 class="mb-3">Liveness Check</h5>
        </div>
        <div class="col-md-4">
          <ul class="row">
            <li class="col-md-6"><label>Is Live</label></li>
            <li class="col-md-6">
              <span>{{
                idbioLivenessResponse?.is_live === true
                  ? "Yes"
                  : idbioLivenessResponse?.is_live === false
                    ? "No"
                    : "NA"
              }}</span>
            </li>
          </ul>
        </div>
        <div class="col-md-4">
          <ul class="row">
            <li class="col-md-6"><label>Liveness Score</label></li>
            <li class="col-md-6">
              <span>{{
                idbioLivenessResponse?.liveness_score?.join(", ") || "NA"
              }}</span>
            </li>
          </ul>
        </div>
        <div class="col-md-4">
          <ul class="row">
            <li class="col-md-6"><label>Message</label></li>
            <li class="col-md-6">
              <span>{{ idbioLivenessResponse?.msg || "NA" }}</span>
            </li>
          </ul>
        </div>
      </div>

      <hr />
      <div class="row">
        <div class="col-md-12">
          <h5 class="mb-3">Face Match Check</h5>
        </div>
        <div class="col-md-4">
          <ul class="row">
            <li class="col-md-6"><label>Is Match</label></li>
            <li class="col-md-6">
              <span>{{
                idbioFaceMatchResponse?.is_match === true
                  ? "Yes"
                  : idbioFaceMatchResponse?.is_match === false
                    ? "No"
                    : "NA"
              }}</span>
            </li>
          </ul>
        </div>
        <div class="col-md-4">
          <ul class="row">
            <li class="col-md-6"><label>Match Score</label></li>
            <li class="col-md-6">
              <span>{{ idbioFaceMatchResponse?.match_score ?? "NA" }}</span>
            </li>
          </ul>
        </div>
        <div class="col-md-4">
          <ul class="row">
            <li class="col-md-6"><label>Error</label></li>
            <li class="col-md-6">
              <span>{{ idbioFaceMatchResponse?.error || "NA" }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div
        class="row"
        *ngIf="
          !kycResponse && !idbioLivenessResponse && !idbioFaceMatchResponse
        "
      >
        <div class="col-md-12">
          <h5 class="text-center">NO DATA FOUND</h5>
        </div>
      </div>
    </div>
  </div>





</div>
